import ServeurRule from './ServeurRule';
import ValidationRules from './ValidationRules';
import toasted from '@/utils/toasted';
import _ from 'lodash';

export default {
  mixins: [ServeurRule, ValidationRules],
  data() {
    return {
      errors: {
        fields: {},
        globals: [],
      },
      control: {
        readonly: true,
        enDemandeModification: false, // indique si l'utilisateur est en mode demande de mofication
        enDemandeSuppression: false, // indique si l'utilisateur est en mode demande de suppression
        enDemandeCreation: false, // indique si l'utilisateur est en mode demande de création
        enDemandeAjoutContact: false, // spécifique à la création de personne physiquue
        enCreation: false, // permet de savoir si l'on est en création directe
        initial: null, // l'état initial
        edited: false, //indique si l'objet est modifié ou non
        onConfirmLeave: null, // le callback du router pour la route
        modalLeave: false,
        modalDelete: false,
        edition: 'AUCUN', //le mode d'edition possible
        entreeEdition: {
          action: this.__entrerEdition,
          loading: false,
        },
        entreeDemande: {
          action: this.__entrerDemande,
          loading: false,
        },
        sauvegardeEdition: {
          action: this.__sauvegarderEdition,
          loading: false,
        },
        entreeSuppression: {
          action: this.__entrerSuppression,
          loading: false,
        },
        entreeSuppressionDirecte: {
          action: this.__entrerSuppressionDirecte,
          loading: false,
        },
        annulerEdition: {
          action: this.__annuler,
        },
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    //en cas de changement dans l'objet demande de confirmation de changement par l'utilisation
    if (this.control.edited && !this.control.readonly) {
      this.control.modalLeave = true;
      this.control.onConfirmLeave = next;
    } else {
      next();
    }
  },

  provide() {
    return {
      control: this.control,
      errors: this.errors,
    };
  },

  watch: {
    form: {
      handler() {
        this.control.edited = this.__isEdited();
      },
      deep: true,
    },
  },

  methods: {
    /**
    initForm(body){

   },
    getForms() {
      //XXX methode à implémenter dans le composant utilisant le mixins
    },

    creationPromiseSauvegarde(id, form) {
      //XXX methode à implémenter dans le composant utilisant le mixins
    },

    creationPromiseEnums() {
      //XXX methode à implémenter dans le composant utilisant le mixins
    },*/

    __isEdited() {
      const eq = _.isEqual(this.form, this.control.initial);
      return !eq;
    },

    __initEdition() {
      const control = this.control;
      control.initial = JSON.parse(JSON.stringify(this.form));
      control.edited = this.__isEdited();
    },

    __entrerEdition() {
      const control = this.control;
      control.entreeEdition.loading = true;

      this.__initEdition();

      // chargement  des enums pour passer en mode edition
      this.creationPromiseEnums()
        .then(() => (control.readonly = false))
        .finally(() => (control.entreeEdition.loading = false));
    },

    __entrerDemande() {
      const control = this.control;
      control.entreeDemande.loading = true;

      this.__initEdition();

      // chargement  des enums pour passer en mode edition
      this.creationPromiseEnums()
        .then(() => {
          control.readonly = false;
          control.enDemandeModification = true;
        })
        .finally(() => (control.entreeDemande.loading = false));
    },

    __entrerSuppression() {
      const control = this.control;
      control.enDemandeSuppression = true;
    },
    __entrerSuppressionDirecte() {
      const control = this.control;
      control.modalDelete = true;
    },

    __annuler(reset = true, forceReadonly = false) {
      if (reset && !this.control.enDemandeSuppression) {
        this.form = JSON.parse(JSON.stringify(this.control.initial));
      }

      const copyControl = JSON.parse(JSON.stringify(this.control));

      //en demande de creation on n'efface pas l'état initial
      if (
        forceReadonly ||
        (!this.control.enDemandeCreation && !this.control.enCreation)
      ) {
        this.control.readonly = true;
        this.control.initial = null;
      }
      this.control.enDemandeModification = false;
      this.control.enDemandeSuppression = false;
      this.control.enDemandeAjoutContact = false;
      this.control.enDemandeCreation = false;
      this.control.enCreation = false;

      this.errors.fields = {};
      this.errors.globals = [];

      this.getForms().forEach(f => {
        if (f) {
          f.resetValidation();
        }
      });

      if (_.isFunction(this.actionApresAnnulation)) {
        this.actionApresAnnulation(copyControl);
      }
    },

    __valider(reset = true) {
      if (reset) {
        //reset des erreurs de validaion du serveurs
        this.errors.fields = {};
        this.errors.globals = [];
      }

      const ok = this.getForms()
        .map(f => f.validate())
        .every(v => !!v);
      return ok;
    },

    /**
     * Accepte les erreurs et mise à jour de la validation des erreurs
     */
    errorsHandler(errors) {
      //mise à jours des erreurs
      const fields = {};
      this.errors.fields = fields;
      this.errors.globals = errors.globalErrors || {};

      if (errors.fieldErrors) {
        errors.fieldErrors.forEach(item => {
          if (!fields[item.field]) {
            fields[item.field] = [];
          }
          fields[item.field].push(item);
        });
        //gestion de la validation des messages du back
        this.__valider(false);
      }
    },

    __sauvegarderEdition() {
      //lance la validation
      const ok = this.__valider();
      if (ok || this.control.enDemandeSuppression) {
        const enDemandeModification = this.control.enDemandeModification;
        const enDemandeSuppression = this.control.enDemandeSuppression;
        const enDemandeCreation = this.control.enDemandeCreation;
        const enCreation = this.control.enCreation;
        this.control.sauvegardeEdition.loading = true;
        this.creationPromiseSauvegarde(this.form.id, this.form)
          .then(response => {
            this.control.edited = false;
            if (enDemandeModification) {
              toasted.info('form.asked');
              this.__annuler(true);
            } else if (enDemandeSuppression) {
              toasted.info('form.askedDelete');
              this.__annuler(true);
            } else if (enDemandeCreation) {
              toasted.info('form.askedcreate');
              const redirect = _.isFunction(this.redirectionApresCreation);
              this.__annuler(false, redirect);
              // en creation direct on a dispose d'un callback spécifique
              if (redirect) {
                this.redirectionApresCreation();
              }
            } else if (enCreation) {
              this.__annuler(false, false);
              this.initForm(response.body);
              toasted.info('form.saved');
              this.redirectionApresCreation();
            } else {
              // modif directe
              this.__annuler(false, false);
              this.initForm(response.body);
              toasted.info('form.saved');
            }
          })
          .catch(errors => this.errorsHandler(errors))
          .finally(() => (this.control.sauvegardeEdition.loading = false));
      }
    },
  },
};
